import React from 'react'
import { useEventListeners } from '@morningtrain/react-helpers'
import get from 'lodash/get'
import set from 'lodash/set'
import has from 'lodash/has'
import clone from 'lodash/clone'

export default function isConstrainable () {
  const constraintsRef = React.useRef({})
  const constraints = constraintsRef.current

  const isMountedRef = React.useRef(true)

  React.useEffect(function () {
    isMountedRef.current = true

    return function () {
      isMountedRef.current = false
    }
  }, [])

  const [triggerOnConstrain, addOnConstrainEventListener, removeOnConstrainEventListener] = useEventListeners()
  const [triggerOnResolve, onResolve, removeOnResolveListener] = useEventListeners()
  const [triggerOnMetaUpdate, onMetaUpdate, removeOnMetaUpdateListener] = useEventListeners()

  const lastConstraintsUuidRef = React.useRef(null)

  const setConstraint = (name, value, triggerChange = true) => {
    set(constraints, name, value)

    if (isMountedRef.current === false) {
      return
    }

    setTimeout(() => {
      if (isMountedRef.current === false) {
        return
      }

      resolveConstraintsWithPromise().then(resolvedConstraints => {
        // var resolvedConstraints = resolveConstraints();
        const nextConstraintsUuid = JSON.stringify(resolvedConstraints)

        if (triggerChange && (lastConstraintsUuidRef.current === null || nextConstraintsUuid !== lastConstraintsUuidRef.current)) {
          lastConstraintsUuidRef.current = nextConstraintsUuid
          triggerOnConstrain(resolvedConstraints)
        }
      })
    }, 0)
  }

  const getConstraint = (name, defaultValue = null) => {
    return get(constraints, name, defaultValue)
  }

  const hasConstraint = (name) => {
    return has(constraints, name)
  }

  const resolveConstraints = () => {
    const newConstraints = clone(constraints)

    triggerOnResolve(newConstraints)

    return newConstraints
  }

  const resolveConstraintsWithPromise = () => {
    const newConstraints = clone(constraints)

    return Promise.resolve(triggerOnResolve(newConstraints))
  }

  const hasConstraints = (name) => {
    return Object.keys(resolveConstraints()).length > 0
  }

  const metaRef = React.useRef({})

  const updateFilterMeta = (data, triggerUpdate = true) => {
    metaRef.current = {
      ...metaRef.current,
      ...data
    }

    if (triggerUpdate === true) {
      triggerOnMetaUpdate(metaRef.current)
    }
  }

  const getFilterMeta = (filter, key, defaultValue = null) => {
    let value = get(metaRef.current, [filter, key].filter(v => v).join('.'), defaultValue)
    if (value === null || typeof value === 'undefined') {
      value = defaultValue
    }
    return value
  }

  const _constrainable = {
    constraints,
    setConstraint,
    getConstraint,
    hasConstraint,
    resolveConstraints,
    resolveConstraintsWithPromise,
    hasConstraints,
    constrain: () => triggerOnConstrain(resolveConstraints()),
    addOnConstrainEventListener,
    removeOnConstrainEventListener,
    onResolve,
    removeOnResolveListener,

    /// Filter meta helpers
    updateFilterMeta,
    getFilterMeta,
    onMetaUpdate,
    removeOnMetaUpdateListener
  }

  return _constrainable
}
